import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=9b530fde&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"
import style0 from "./edit.vue?vue&type=style&index=0&id=9b530fde&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b530fde",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9b530fde')) {
      api.createRecord('9b530fde', component.options)
    } else {
      api.reload('9b530fde', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=9b530fde&scoped=true", function () {
      api.rerender('9b530fde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/commodityreference/edit.vue"
export default component.exports